export default import.meta.ROLLDOWN_FILE_URL_8F1OtDtFq6dBtN6l2YS93w